import React from 'react';
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';

/**
 * Renders Hindi/English markdown text inside quiz/flashcards/chat.
 * Supports GFM tables, bold, italic, lists, code, headings.
 */
export const MD = ({ children, className = '', accent = 'mint' }) => {
  const accentCls = accent === 'mint' ? 'text-mint' : accent === 'bblue' ? 'text-bblue' : 'text-foreground';
  return (
    <div className={`md-content ${className}`}>
      <ReactMarkdown
        remarkPlugins={[remarkGfm]}
        components={{
          p: ({ children }) => <p className="mb-1.5 last:mb-0 leading-relaxed">{children}</p>,
          strong: ({ children }) => <strong className={`font-bold ${accentCls}`}>{children}</strong>,
          em: ({ children }) => <em className="italic">{children}</em>,
          ul: ({ children }) => <ul className="list-disc pl-5 space-y-0.5 my-1.5">{children}</ul>,
          ol: ({ children }) => <ol className="list-decimal pl-5 space-y-0.5 my-1.5">{children}</ol>,
          li: ({ children }) => <li className="leading-relaxed">{children}</li>,
          h1: ({ children }) => <h1 className="text-base font-bold mt-2 mb-1">{children}</h1>,
          h2: ({ children }) => <h2 className="text-[14px] font-bold mt-2 mb-1">{children}</h2>,
          h3: ({ children }) => <h3 className="text-[13.5px] font-semibold mt-1.5 mb-1">{children}</h3>,
          code: ({ inline, children }) => inline
            ? <code className="bg-secondary px-1 rounded text-[12.5px]">{children}</code>
            : <pre className="bg-secondary p-2 rounded overflow-auto text-[12px]"><code>{children}</code></pre>,
          a: ({ children, href }) => <a href={href} target="_blank" rel="noreferrer" className="text-bblue underline">{children}</a>,
          table: ({ children }) => <div className="overflow-x-auto"><table className="md-table">{children}</table></div>,
          thead: ({ children }) => <thead>{children}</thead>,
          tbody: ({ children }) => <tbody>{children}</tbody>,
          tr: ({ children }) => <tr>{children}</tr>,
          th: ({ children }) => <th>{children}</th>,
          td: ({ children }) => <td>{children}</td>,
          blockquote: ({ children }) => <blockquote className="border-l-2 border-mint/40 pl-3 my-2 text-foreground/80 italic">{children}</blockquote>,
        }}
      >
        {children || ''}
      </ReactMarkdown>
    </div>
  );
};

export default MD;
